import styles from './ChamadoForm.module.css';
import SelectMultiple from '../form/SelectMultiple'
import SubmitBtn from '../form/SubmitBtn';
import { __URL, __PRIORIDADES, __SITUACOES } from '../../config';
import { forwardRef, useImperativeHandle, useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';


const ChamadoForm = forwardRef(({ handleSubmit, btnText, chamadoData, isEditing }, ref) => {
    const [userSession] = useState(JSON.parse(localStorage.getItem('userSession')));
    const [chamado] = useState(chamadoData || {});
    const [motivos, setMotivos] = useState([]);
    const [motivosSelecionados, setMotivosSelecionados] = useState([]);
    const [prioridadeSelecionada, setPrioridadeSelecionada] = useState([]);
    const [prioridades] = useState(__PRIORIDADES);
    const [situacaoSelecionada, setSituacaoSelecionada] = useState(chamadoData?.TP_SITUACAO ? [chamadoData.TP_SITUACAO] : []);
    const [responsaveis, setResponsaveis] = useState([]);
    const [responsaveisSelecionados, setResponsaveisSelecionados] = useState(
        chamadoData?.USUARIOS
            ?.filter(usr => parseInt(usr.ATRIBUICAO) === 3)
            ?.map(usr => Number(usr.ID_USUARIO ?? usr.ID))
            ?.filter((id) => Number.isFinite(id)) || []
    );
    const responsavelValue = (resp) => Number(resp.ID_USUARIO ?? resp.ID);

    useImperativeHandle(ref, () => ({
        submitForm: () => {
            handleFormSubmit();
        },
        validateForm: () => {
            return validateFormData();
        },
        getFormData: () => {
            return {
                chamado,
                motivos: motivosSelecionados,
                prioridadeInterna: prioridadeSelecionada,
                situacao: situacaoSelecionada[0] || '',
                usuarios: responsaveisSelecionados,
                // responsaveis: responsaveis
            };
        }
    }));

    const validateFormData = () => {
        const erros = [];

        if (!motivosSelecionados || motivosSelecionados.length === 0) {
            erros.push("Preencha um motivo.");
        }

        if (!prioridadeSelecionada || prioridadeSelecionada.length === 0) {
            erros.push("Selecione uma prioridade.");
        }

        return erros;
    };

    const handleFormSubmit = () => {
        const erros = validateFormData();
        if (erros.length === 0) {            
            const formData = {
                chamado,
                motivos: motivosSelecionados,
                prioridadeInterna: prioridadeSelecionada,
                situacao: situacaoSelecionada[0] || '',
                usuarios: responsaveisSelecionados,
                // responsaveis: responsaveis
            };
            // console.log("ChamadoForm.js - handleFormSubmit - Responsáveis", formData.usuarios, '____', formData.responsaveis);
            let submitPromise;
            try {
                submitPromise = Promise.resolve(handleSubmit(formData));
            } catch (err) {
                submitPromise = Promise.reject(err);
            }
            toast.promise(
                submitPromise,
                {
                    pending: 'Salvando chamado...',
                    success: {
                        render: () => 'Chamado salvo com sucesso!',
                        autoClose: 9000
                    },
                    error: {
                        render: ({data}) => `Erro ao salvar: ${data?.message || 'Erro desconhecido'}`,
                        autoClose: 9000
                    }
                },
                {
                    position: "top-right",
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                    icon: "🚀"
                }
            );
            return true;
        } else {
            toast.warn(erros.join('\n'), {
                position: "top-right",
                autoClose: 9000,
                theme: "colored",
                closeOnClick: false
            });
            return false;
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();
        handleFormSubmit();
    };

    useEffect(() => {

        if (motivos.length === 0) {

            fetch(__URL + '/chamado/filter', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${window.btoa(`${userSession.TX_EMAIL}:${userSession.TX_HASH}`)}`
                }
            })
                .then(resp => resp.status === 200 ? resp.json() : false)
                .then((data) => {
                    if (data !== false) {
                        setMotivos(data.data.MOTIVOS);
                        setResponsaveis(data.data.RESPONSAVEIS);
                        
                        if (chamadoData) {
                            if (chamadoData.PRIORIDADE_INTERNA) {
                                setPrioridadeSelecionada([parseInt(chamadoData.PRIORIDADE_INTERNA)]);
                            }
                            
                            if (chamadoData.MOTIVOS?.length > 0) {
                                setMotivosSelecionados(chamadoData.MOTIVOS.map(mtv => mtv.ID_MOTIVO));
                            }
                            
                            if (chamadoData.USUARIOS?.length > 0) {
                                const responsaveisIds = chamadoData.USUARIOS
                                    .filter(usr => parseInt(usr.ATRIBUICAO) === 3)
                                    .map(usr => Number(usr.ID_USUARIO ?? usr.ID))
                                    .filter((id) => Number.isFinite(id));
                                setResponsaveisSelecionados(responsaveisIds);
                            }
                        }
                    }
                })
                .catch((err) => console.error(err));
        }

    }, [userSession, setMotivosSelecionados, setMotivos, chamadoData, setResponsaveisSelecionados]);

    const submit = (e) => {
        e.preventDefault();
        let formResponse = {
            chamado: chamado,
            motivos: motivosSelecionados,
            prioridadeInterna: prioridadeSelecionada,
            situacao: situacaoSelecionada[0] || '',
            usuarios: responsaveisSelecionados
        };

        let erros = [];

        if (motivosSelecionados !== undefined && motivosSelecionados.length > 0)
            motivos.TX_MOTIVO = motivosSelecionados;
        else
            erros.push("Preencha um motivo.");

        if (erros.length === 0)
            handleSubmit(formResponse);
        else
            toast.warn(erros, {
                theme: "dark"
            });
    }

    const handleMotivo = (e) => {
        if (!e || e.length === 0) {
            setMotivosSelecionados([]);
            return;
        }
        const selectedValues = e.map(select => select.value);
        setMotivosSelecionados(selectedValues);
    }

    const handleResponsavel = (e) => {
        if (!e || e.length === 0) {
            setResponsaveisSelecionados([]);
            return;
        }
        const selectedValues = e
            .map(select => Number(select.value))
            .filter((id) => Number.isFinite(id));
        setResponsaveisSelecionados(selectedValues);
    }

    const handleSituacao = (e) => {
        setSituacaoSelecionada(e ? [e.value] : []);
    }

    const handlePrioridades = (e) => {
        if (!e) {
            setPrioridadeSelecionada([]);
            return;
        }
        setPrioridadeSelecionada([e.value]);
    }


    return (
        <form onSubmit={onSubmit} className={styles.form}>
            <div className={styles.select}>
                <SelectMultiple
                    isMulti={true}
                    handleOnChange={handleMotivo}
                    name="motivos"
                    text="Motivos"
                    options={motivos.map((mtv) => ({
                        value: mtv.ID,
                        label: mtv.TX_MOTIVO
                    }))}
                    value={motivosSelecionados}
                />
            </div>
            <div className={styles.select}>
                <SelectMultiple
                    isMulti={false}
                    handleOnChange={handlePrioridades}
                    name="chm_prioridade_interna"
                    text="Prioridade"
                    options={prioridades}
                    value={prioridadeSelecionada}
                />
            </div>
            <div className={styles.select}>
                <SelectMultiple
                    isMulti={false}
                    isClearable={true}
                    handleOnChange={handleSituacao}
                    name="chm_situacao"
                    text="Situação"
                    options={__SITUACOES}
                    value={situacaoSelecionada}
                />
            </div>
            <div className={styles.select}>
                <SelectMultiple
                    isMulti={true}
                    handleOnChange={handleResponsavel}
                    name="usuarios"
                    text="Responsável"
                    options={responsaveis.map((resp) => ({
                        value: responsavelValue(resp),
                        label: resp.CD_USUARIO
                    }))}
                    value={responsaveisSelecionados}
                    />
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                limit={3}
            />          
            {!isEditing && (
                <div className={styles.submit}>
                    <SubmitBtn text={btnText} />
                </div>
            )}
        </form>
    );
});

ChamadoForm.displayName = 'ChamadoForm';

export default ChamadoForm;
